import { __ } from "@wordpress/i18n";
import { useSettingsContext } from "../../../../hook/useSettingsContext";
import SettingsForm from "../../SettingsForm";
import FieldWrapper from "../../../../components/UI/common/FieldWrapper";
import SwitchRoot from "../../../../components/UI/SwitchRoot";
import Switch from "../../../../components/UI/switch";
import Wrapper from "../../../../components/UI/common/Wrapper";
import Input from "../../../../components/UI/Input";
import Errors from "../../../../components/Errors";

export default function QuantitySettings() {
    const {
        getSection,
        getOption,
        handleToggle,
        handleInputChange,
        qtyValidationMessages,
    } = useSettingsContext();

    const sectionID = "quantity";
    const section = getSection(sectionID);

    //console.log(section);

    return (
        <SettingsForm
            title={__(
                "Universal Quantity Settings",
                "wpbean-quantity-controls-for-woocommerce",
            )}
            subtitle={__(
                "Universal quantity settings for min, max, step, default quantity and other options. For specific quantity, please use the Rules settings.",
                "wpbean-quantity-controls-for-woocommerce",
            )}
        >
            <SwitchRoot
                label={__(
                    "Universal Quantity Rule",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Universal quantity rule for all the products.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <Switch
                    checked={getOption("universalQuantity", sectionID)}
                    onChange={(value) =>
                        handleToggle(section, "universalQuantity", value)
                    }
                />
            </SwitchRoot>
            {getOption("universalQuantity", sectionID) && (
                <>
                    <Errors errors={qtyValidationMessages} />
                    <FieldWrapper
                        label={__(
                            "Minimum Quantity",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        description={__(
                            "Defines the lowest quantity allowed when adjusting the product quantity.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <Input
                            name="quantityMin"
                            type="number"
                            min="0"
                            value={getOption("quantityMin", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Maximum Quantity",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        description={__(
                            "Defines the highest quantity allowed when adjusting the product quantity.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <Input
                            name="quantityMax"
                            type="number"
                            min="0"
                            value={getOption("quantityMax", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Quantity Step",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        description={__(
                            "Defines how much the quantity increases or decreases with each click of the plus/minus buttons.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <Input
                            name="quantityStep"
                            type="number"
                            min="0"
                            allowDecimal={getOption("allowDecimal", sectionID)}
                            value={getOption("quantityStep", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                    <FieldWrapper
                        label={__(
                            "Default Quantity",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        description={__(
                            "Default Quantity - The initial quantity value displayed when customers view the product.",
                            "wpbean-quantity-controls-for-woocommerce",
                        )}
                        width="30"
                        containerClass="flex justify-between items-center lg:gap-10 gap-4"
                        fieldsClass=""
                    >
                        <Input
                            name="defaultQuantity"
                            type="number"
                            min="0"
                            allowDecimal={getOption("allowDecimal", sectionID)}
                            value={getOption("defaultQuantity", sectionID)}
                            onChange={(key, value) =>
                                handleInputChange(section, key, value)
                            }
                        />
                    </FieldWrapper>
                </>
            )}
            <SwitchRoot
                label={__(
                    "Allow Decimal Quantities",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Allows customers to enter fractional quantities (e.g., 0.5, 1.25).",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <Switch
                    checked={getOption("allowDecimal", sectionID)}
                    onChange={(value) =>
                        handleToggle(section, "allowDecimal", value)
                    }
                />
            </SwitchRoot>
            <SwitchRoot
                label={__(
                    "Allow Manual Input",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
                description={__(
                    "Allows customers to manually input the quantity.",
                    "wpbean-quantity-controls-for-woocommerce",
                )}
            >
                <Switch
                    checked={getOption("allowManualInput", sectionID)}
                    onChange={(value) =>
                        handleToggle(section, "allowManualInput", value)
                    }
                />
            </SwitchRoot>
            {getOption("allowManualInput", sectionID) && (
                <SwitchRoot
                    label={__(
                        "Manual Input Validation",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                    description={__(
                        "Validate the quantity manual input based on the min, max and step of the quantity.",
                        "wpbean-quantity-controls-for-woocommerce",
                    )}
                >
                    <Switch
                        checked={getOption("validateManualInput", sectionID)}
                        onChange={(value) =>
                            handleToggle(section, "validateManualInput", value)
                        }
                    />
                </SwitchRoot>
            )}
        </SettingsForm>
    );
}
